import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/logo-white.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-b933d146")

_pushScopeId("data-v-b933d146")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row sticky" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "row"
}
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "col-12 text-left" }, " Your account has been suspended. Please contact support. ", -1)
const _hoisted_9 = { class: "col-12 text-left" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 col-lg-5 col-xl-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "card shadow"
}
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-12 col-sm-6" }
const _hoisted_17 = {
  key: 0,
  class: "pair-item pair-item-value"
}
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "pair-item" }
const _hoisted_20 = { class: "col-12 col-sm-6 text-sm-right" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "font-weight-bold text-secondary block" }, "|", -1)
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = {
  key: 1,
  class: "card shadow opacity-75 p-4",
  style: {"opacity":"0.6"}
}
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { style: {"text-align":"center","width":"100%"} }, [
  /*#__PURE__*/_createVNode("div", { style: {"margin":"auto","text-align":"left"} }, [
    /*#__PURE__*/_createVNode("img", {
      class: "mt-3",
      src: _imports_0,
      style: {"max-width":"300px"},
      alt: "logo satstreet"
    }),
    /*#__PURE__*/_createVNode("p", { class: "text-info p-3" }, " To enable automatic trading please contact your assigned trader. ")
  ])
], -1)
const _hoisted_25 = { class: "col-12 col-lg-7 col-xl-8 text-center" }
const _hoisted_26 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_27 = { class: "card shadow" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = {
  class: "col-12",
  style: {"height":"373px"}
}
const _hoisted_31 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-12" }
const _hoisted_34 = { class: "p-0" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_balances = _resolveComponent("balances")
  const _component_Message = _resolveComponent("Message")
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_AdvanceTransaction = _resolveComponent("AdvanceTransaction")
  const _component_tradingViewWidget = _resolveComponent("tradingViewWidget")
  const _component_CryptoBalances = _resolveComponent("CryptoBalances")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_OrderHistory = _resolveComponent("OrderHistory")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_balances, {
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCurrency($event)))
          })
        ])
      ]),
      (_ctx.userProfile.isSuspended)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_Message, {
                closable: false,
                severity: "warn"
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("div", _hoisted_9, [
                      _createVNode("small", null, _toDisplayString(_ctx.userProfile.suspensionReason), 1)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          (!_ctx.showOverlay)
            ? (_openBlock(), _createBlock("div", _hoisted_13, [
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.parity,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.parity = $event)),
                        options: _ctx.pairs,
                        optionLabel: "pairId",
                        filter: true,
                        placeholder: "Select a Pair",
                        showClear: true
                      }, {
                        value: _withId((slotProps) => [
                          (slotProps.value)
                            ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                _createVNode("div", null, _toDisplayString(slotProps.value.pair?.baseCurrencyId) + "/" + _toDisplayString(slotProps.value.pair?.quoteCurrencyId), 1)
                              ]))
                            : (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(slotProps.placeholder), 1))
                        ]),
                        option: _withId((slotProps) => [
                          _createVNode("div", _hoisted_19, [
                            _createTextVNode(_toDisplayString(slotProps.option.pair?.baseCurrencyId) + "/" + _toDisplayString(slotProps.option.pair?.quoteCurrencyId) + " ", 1),
                            _createVNode(_component_icons_currency, {
                              pairType: 
                            !_ctx.isFiat(slotProps.option.pair?.quoteCurrencyId)
                              ? 'crypto'
                              : _ctx.isFiat(slotProps.option.pair?.baseCurrencyId)
                              ? 'fiat'
                              : null
                          ,
                              localCurrency: 
                            slotProps.option.pair?.quoteCurrencyId
                          ,
                              cryptoCurrency: 
                            slotProps.option.pair?.baseCurrencyId
                          ,
                              width: '20',
                              height: '20',
                              color: true,
                              reverse: _ctx.type == 'BUY' ? false : true
                            }, null, 8, ["pairType", "localCurrency", "cryptoCurrency", "reverse"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options"])
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("button", {
                        disabled: !_ctx.parity?.pair?.allowBuy,
                        class: ["btn font-weight-bold", _ctx.type == 'BUY' ? 'text-success' : 'text-secondary'],
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchTrans('BUY'))),
                        href: "#"
                      }, " BUY ", 10, ["disabled"]),
                      _hoisted_21,
                      _createVNode("button", {
                        disabled: !_ctx.parity?.pair?.allowSell,
                        class: ["btn font-weight-bold", _ctx.type == 'SELL' ? 'text-danger' : 'text-secondary'],
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchTrans('SELL'))),
                        href: "#"
                      }, " SELL ", 10, ["disabled"])
                    ]),
                    _createVNode("div", _hoisted_22, [
                      (_ctx.parity)
                        ? (_openBlock(), _createBlock(_component_AdvanceTransaction, {
                            key: 0,
                            type: _ctx.type,
                            parity: _ctx.parity,
                            tradeType: "market"
                          }, null, 8, ["type", "parity"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_23, [
                _hoisted_24
              ]))
        ]),
        _createVNode("div", _hoisted_25, [
          _hoisted_26,
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _createVNode("div", _hoisted_30, [
                  _createVNode(_component_tradingViewWidget, {
                    pairId: _ctx.parity?.pairId
                  }, null, 8, ["pairId"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _hoisted_31,
      _createVNode("div", _hoisted_32, [
        _createVNode("div", _hoisted_33, [
          _createVNode(_component_TabView, { activeIndex: _ctx.indexTab }, {
            default: _withId(() => [
              _createVNode(_component_TabPanel, { header: "Portfolio balance" }, {
                default: _withId(() => [
                  _createVNode(_component_CryptoBalances, { initialLocalCurrency: _ctx.currencyBalance }, null, 8, ["initialLocalCurrency"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, { header: "Order History" }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_34, [
                    _createVNode(_component_OrderHistory)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ])
      ])
    ])
  ]))
})